import audioPackData from '@/data/audio-packs.json';

export type AudioFileKey = keyof typeof audioPackData.keys;
export type AudioPackId = keyof typeof audioPackData.packs;

interface AudioPackData {
  activePackId: AudioPackId;
  keys: Record<AudioFileKey, string>;
  packs: Record<AudioPackId, { label: string; basePath: string }>;
}

const data: AudioPackData = audioPackData as AudioPackData;

export interface AudioPackConfig {
  id: AudioPackId;
  label: string;
  basePath: string;
}

export const AUDIO_KEYS: AudioFileKey[] = Object.keys(data.keys) as AudioFileKey[];

export function getAudioFileName(key: AudioFileKey): string {
  const file = data.keys[key];
  if (!file) {
    throw new Error(`Audio key "${key}" is not defined`);
  }
  return file;
}

export function getAudioPack(id: AudioPackId): AudioPackConfig {
  const pack = data.packs[id];
  if (!pack) {
    throw new Error(`Audio pack "${id}" is not defined`);
  }
  return { id, label: pack.label, basePath: pack.basePath };
}

export function getActiveAudioPack(): AudioPackConfig {
  return getAudioPack(data.activePackId);
}
